<template>
    <customer-layout>
        <div class="relative min-h-screen px-4 py-2 bg-gray-100">
            <div class="flex items-center justify-between">
                <h2 class="text-4xl font-bold text-pink-500">Cart List</h2>
                <div class="flex items-center">
                    <div>Total = </div>
                    <div class="pr-2"> {{ newTotal }}</div>
                    <img src="/img/icons/coin-black.svg" class="w-4 h-4">
                </div>
            </div>
            <div v-if="newCarts.length > 0" class="mt-2 mb-16">
                <div class="flex justify-end text-xs">
                    <a href="shop">
                        ⬅️ <span class="underline">back to shop</span>
                    </a>
                </div>
                <div v-for="cart in newCarts" :key="cart.id" class="mt-2">
                    <div class="flex items-center justify-between p-2 bg-pink-100 border-2 border-pink-600 rounded-md shadow-sm md:w-1/2">
                        <div class="flex items-center">
                            <img :src="cart.user_cart.cover_image" alt="product" class="w-12 h-12 p-1 mr-1 bg-white border-gray-200 rounded-full shadow-sm">
                            <div class="w-32 text-sm sm:text-base sm:w-full">{{ cart.user_cart.name }}</div>
                        </div>
                        <div class="flex items-center">
                            <div class="pr-2">{{ cart.user_cart.price }}</div>
                            <img src="/img/icons/coin-black.svg" class="w-4 h-4 pr-2">
                            <div @click="removeCartProduct(cart.id)" class="p-1 bg-white rounded-full shadow-md cursor-pointer">
                                <img src="/img/icons/delete.png" alt="delete" class="w-4 h-4">
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="error.length > 0" class="my-1 text-sm font-bold text-red-600">
                    {{ error }}
                </div>
                <div v-if="!processUpdate" class="text-right sm:text-left">
                    <button @click="placeOrder" class="px-4 py-2 my-3 text-sm font-bold text-green-600 bg-green-100 border-2 border-green-600 rounded-md">complete order</button>
                </div>
                <div v-else class="text-right sm:text-left">
                    <div class="px-4 py-2 my-3 text-sm font-bold text-green-600 bg-green-100 border-2 border-green-600 rounded-md sm:w-2/4">
                        please wait, order is in process....
                    </div>
                </div>
            </div>
            <div v-else class="top-0 flex flex-col items-center justify-center w-full h-full min-h-screen -mt-14">
                <img src="/img/icons/online-shopping.png" alt="shopping" class="w-20 h-20">
                <span class="text-sm">{{ $t("There is nothing in you cart.") }} <a href="shop" class="underline">{{ $t("Let's add some items.") }}</a></span>
                <a href="new_audiobooks"><span class="text-sm text-pink-600 underline">{{ $t("check purchased product") }}</span></a>
            </div>
            <!-- success banner -->
            <SuccessBanner v-show="successBanner" :message="message"></SuccessBanner>
            <!-- Thank you banner -->
            <ThankYouBanner v-show="thanksBanner" :message="message"></ThankYouBanner>
            <!-- already exists banner -->
            <WarningBanner v-show="warningBanner" :message="message"></WarningBanner>
        </div>
    </customer-layout>
</template>
<script>
    import ThankYouBanner from "../../Components/PopUpBanner/ThankYou.vue";
    import WarningBanner from "../../Components/PopUpBanner/Warning.vue";
    import SuccessBanner from "../../Components/PopUpBanner/Success.vue";
    import CustomerLayout from '../../Layouts/CustomerLayout.vue';

    export default {
        props: ['carts', 'total', 'current', 'diamonds'],
        components: {
            ThankYouBanner,
            WarningBanner,
            SuccessBanner,
            CustomerLayout
        },
        data(){
            return {
                newCarts: this.carts,
                newTotal: this.total,
                thanksBanner: false,
                warningBanner: false,
                successBanner: false,
                message: "",
                error: "",
                processUpdate: false
            }
        },
        methods: {
            removeCartProduct(value) {
                let custObj = this;
                const token = localStorage.getItem('token');
                const headers = { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                };
                axios.delete("/cart/remove-product/"+value,{headers})
                .then(function (response) {
                    if(response.data.status == 200) {
                        custObj.newCarts = response.data.carts;
                        custObj.newTotal = response.data.total;
                        custObj.message = response.data.message;
                        custObj.successBanner = true;
                        setTimeout(() => {
                            custObj.successBanner = false
                        }, 1000)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            placeOrder() {
                let custObj = this;
                const token = localStorage.getItem('token');
                const headers = { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                };
                this.processUpdate = true;
                axios.post("/cart/complete-order",{
                    total: this.newTotal,
                    products : this.newCarts,
                },{headers})
                .then(function (response) {
                    if(response.data.status == 200) {
                        custObj.newCarts = response.data.carts;
                        custObj.newTotal = response.data.total;
                        custObj.message = response.data.message;
                        custObj.thanksBanner = true;
                        setTimeout(() => {
                            custObj.thanksBanner = false
                        }, 1000)
                    }
                    if(response.data.status == 400){
                        custObj.processUpdate = false;
                        custObj.message = response.data.message;
                        custObj.error = "sorry, your OSM Coin balance is not enough to proceed. Earn more OSM Coin in Virtual Coach to continue…";
                        custObj.WarningBanner = true;
                        setTimeout(() => {
                            custObj.WarningBanner = false,
                            custObj.error = ""
                        }, 3000)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    this.processUpdate = false;
                });
            }
        }
    }
</script>